import { authApi } from "@api";
import { APP_INSTALLER_HEIGHT } from "@constants/ui";
import useTypedSelector from "@hooks/useTypedSelector";
import { Select, SelectProps, cn } from "kz-ui-sdk";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MdAccountBalance } from "react-icons/md";

interface BankSelectProps extends Omit<SelectProps<{ id: string; name: string }>, "label" | "options"> {}

const BankSelect: React.FC<BankSelectProps> = ({ ...props }: BankSelectProps) => {
  const { data } = authApi.useGetProfileQuery();
  const { t } = useTranslation();
  const isDisplayAppInstaller = useTypedSelector((state) => state.preferences.isDisplayAppInstaller);

  const bankList = useMemo(() => {
    const bankMap = data?.bankInfos;

    return Object.entries(bankMap ?? {})
      .filter(([_, bankConfig]) => !!bankConfig.visibility)
      .sort(([, lhsBank], [, rhsBank]) => (lhsBank.sort ?? 0) - (rhsBank.sort ?? 0))
      .map(([bankKey, bankConfig]) => ({
        id: bankKey,
        name: `${bankConfig.name} ${bankKey ? `(${bankKey})` : ""}`,
        icon: !!bankConfig.icon ? (
          <img
            src={bankConfig.icon}
            alt={bankConfig.name}
            className={cn(`mt-0.5 h-[24px] w-[24px] flex-shrink-0 self-start object-contain`)}
          />
        ) : null,
      }));
  }, [data?.bankInfos]);

  return (
    <Select
      {...props}
      icon={
        <div>
          <MdAccountBalance
            className="text-content-base"
            size={24}
          />
        </div>
      }
      placeholder={t("Select bank")}
      options={bankList}
      optionIconPlaceholder={<div className="mt-0.5 h-[24px] w-[24px] flex-shrink-0" />}
      size={"lg"}
      dropdownGap={isDisplayAppInstaller ? APP_INSTALLER_HEIGHT : undefined}
      classes={{
        "root&": "gap-0",
        "label&": "text-content-base text-base",
        "placeHolder&": cn("text-content-soft text-left w-56", {
          "text-content-base": !!props.value,
        }),
        "helperText&": "!mt-1 !text-xs my-0 px-0",
        "selectedOption&": "!text-content-base text-base",
      }}
    />
  );
};

export default BankSelect;
